import React from 'react';
import PropTypes from 'prop-types';
import iconCardAmex from '../../images/wom-pay/iconCardAmex.svg';
import iconCardDiners from '../../images/wom-pay/iconCardDiners.svg';
import iconCardMagna from '../../images/wom-pay/iconCardMagna.svg';
import iconCardMasterCard from '../../images/wom-pay/iconCardMasterCard.svg';
import iconCardVisa from '../../images/wom-pay/iconCardVisa.svg';
import {
  TableResumenTransactionBodyTextStyled,
  TableResumenTransactionBodyImageStyled,
} from './styles/WomPayTableResumenStyled';

const CardNumberComponent = ({ cardType, lastFour }) => {
  const iconCard = {
    amex: iconCardAmex,
    diners: iconCardDiners,
    magna: iconCardMagna,
    mastercard: iconCardMasterCard,
    visa: iconCardVisa,
  };

  return (
    <TableResumenTransactionBodyTextStyled>
      <TableResumenTransactionBodyImageStyled
        src={iconCard[cardType.toLowerCase()]}
        alt="icon card"
      />
      {` ***${lastFour}`}
    </TableResumenTransactionBodyTextStyled>
  );
};

CardNumberComponent.propTypes = {
  cardType: PropTypes.string.isRequired,
  lastFour: PropTypes.string.isRequired,
};

export default CardNumberComponent;
